export const TXTWCL_Does_not_include_N0 = {
  "id": "TXTWCL_Does_not_include_N0",
  "defaultMessage": "Does not include {0}"
} as const;